import(/* webpackMode: "eager" */ "/project/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/project/packages/client/src/components/Navbar/NavbarLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/project/packages/client/src/components/TemplateCard/TemplateCard.tsx");
